(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeader = document.querySelector('sticky-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.navOnScrollUp = this.getAttribute('data-sticky-type') === 'nav-on-scroll-up' //header always sticky, Nav bar on scroll up
      this.nav = this.querySelector('.js-nav')
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));
      
      if(this.navOnScrollUp) document.documentElement.style.setProperty('--header-nav-height', `${this.nav.offsetHeight}px`);

      if (this.headerIsAlwaysSticky || this.navOnScrollUp) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', (event) => {
        this.onScrollHandler(event);  
      }, false);

      this.createObserver();

    }

    setStickyHeaderHeight() {
      if (this.stickyHeader) {
        document.documentElement.style.setProperty('--sticky-header-height', `${this.stickyHeader.offsetHeight - this.nav.offsetHeight }px`);
      }
    }
    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setStickyHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const colorScheme = this.header.querySelector('sticky-header').dataset.colorScheme;
      const stickyColorScheme = this.header.querySelector('sticky-header').dataset.stickyColorScheme;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

      
        this.header.querySelector('sticky-header').classList.remove(colorScheme);
        this.header.querySelector('sticky-header').classList.add(stickyColorScheme);
        if(this.navOnScrollUp) this.header.classList.add('shopify-section-header-nav-hidden');
        this.setStickyHeaderHeight();

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.querySelector('sticky-header').classList.add(colorScheme);
        this.header.querySelector('sticky-header').classList.remove(stickyColorScheme);
        if(this.navOnScrollUp) this.header.classList.remove('shopify-section-header-nav-hidden');
        this.setStickyHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Open menu dropdowns on hover
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

  items.forEach((item) => {
    const summary = item.querySelector("summary");
    item.addEventListener("click", (event) => {
      if (!event.target.closest('.mega-menu__content')) {
        event.preventDefault();
      }
    });
    item.addEventListener("mouseover", () => {
      if (item.classList.contains("closing")) {
        item.classList.remove("closing");
      }

      item.setAttribute("open", true);
      summary.setAttribute("aria-expanded", "true");
    });

    item.addEventListener("mouseleave", () => {
      item.classList.add("closing");
      summary.setAttribute("aria-expanded", "false");
    });

    item.addEventListener("animationend", (e) => {
      if (e.animationName === "close-megamenu") {
        item.classList.remove("closing");
        item.removeAttribute("open");
      }
    });
  });

     // Brand carousel auto-scroll - Starts when mega menu opens                                                                      
  (function() {                                                                                                                    
    const megaMenus = document.querySelectorAll("details.mega-menu");                                                              
                                                                                                                                   
    megaMenus.forEach((menu, index) => {                                                                                           
      const carousel = menu.querySelector(".megamenu-logo-images");                                                                
      if (!carousel) return;                                                                                                       
                                                                                                                                   
      let scrollInterval = null;                                                                                                   
      let isDragging = false;                                                                                                      
      let startX, scrollLeft;                                                                                                      
      const scrollSpeed = 1;                                                                                                       
                                                                                                                                   
      function startAutoScroll() {                                                                                                 
        if (scrollInterval) return;                                                                                                
        carousel.scrollLeft = 0;                                                                                                   
        carousel.classList.add('auto-scrolling'); // Disable snap/smooth                                                           
                                                                                                                                   
        scrollInterval = setInterval(() => {                                                                                       
          if (!isDragging) {                                                                                                       
            carousel.scrollLeft += scrollSpeed;                                                                                    
                                                                                                                                   
            if (carousel.scrollLeft >= (carousel.scrollWidth - carousel.clientWidth - 10)) {                                       
              carousel.scrollLeft = 0;                                                                                             
            }                                                                                                                      
          }                                                                                                                        
        }, 30);                                                                                                                    
      }                                                                                                                            
                                                                                                                                   
      function stopAutoScroll() {                                                                                                  
        if (scrollInterval) {                                                                                                      
          clearInterval(scrollInterval);                                                                                           
          scrollInterval = null;                                                                                                   
          carousel.classList.remove('auto-scrolling'); // Re-enable snap/smooth                                                    
        }                                                                                                                          
      }                                                                                                                            
                                                                                                                                   
      // Watch for open attribute changes                                                                                          
      const observer = new MutationObserver((mutations) => {                                                                       
        mutations.forEach((mutation) => {                                                                                          
          if (mutation.attributeName === 'open') {                                                                                 
            if (menu.hasAttribute('open')) {                                                                                       
              startAutoScroll();                                                                                                   
            } else {                                                                                                               
              stopAutoScroll();                                                                                                    
            }                                                                                                                      
          }                                                                                                                        
        });                                                                                                                        
      });                                                                                                                          
                                                                                                                                   
      observer.observe(menu, { attributes: true });                                                                                
                                                                                                                                   
      // Drag functionality                                                                                                        
      carousel.addEventListener("mousedown", (e) => {                                                                              
        isDragging = true;                                                                                                         
        carousel.classList.remove('auto-scrolling'); // Allow manual snap while dragging                                           
        carousel.style.cursor = 'grabbing';                                                                                        
        startX = e.pageX - carousel.offsetLeft;                                                                                    
        scrollLeft = carousel.scrollLeft;                                                                                          
      });                                                                                                                          
                                                                                                                                   
      carousel.addEventListener("mouseup", () => {                                                                                 
        carousel.style.cursor = 'grab';                                                                                            
        setTimeout(() => {                                                                                                         
          isDragging = false;                                                                                                      
          if (scrollInterval) carousel.classList.add('auto-scrolling');                                                            
        }, 100);                                                                                                                   
      });                                                                                                                          
                                                                                                                                   
      carousel.addEventListener("mouseleave", () => {                                                                              
        if (isDragging) {                                                                                                          
          carousel.style.cursor = 'grab';                                                                                          
          setTimeout(() => {                                                                                                       
            isDragging = false;                                                                                                    
            if (scrollInterval) carousel.classList.add('auto-scrolling');                                                          
          }, 100);                                                                                                                 
        }                                                                                                                          
      });                                                                                                                          
                                                                                                                                   
      carousel.addEventListener("mousemove", (e) => {                                                                              
        if (!isDragging) return;                                                                                                   
        e.preventDefault();                                                                                                        
        const x = e.pageX - carousel.offsetLeft;                                                                                   
        const walk = (x - startX) * 2;                                                                                             
        carousel.scrollLeft = scrollLeft - walk;                                                                                   
      });                                                                                                                          
                                                                                                                                   
      carousel.style.cursor = 'grab';                                                                                              
    });                                                                                                                            
  })();                                                                                                                            
                            

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const quickLinkLists = document.querySelectorAll('.collection-quick-link-list').forEach((quickLinkList) => {
    let startX;
    let scrollLeft;
    let isDown;

    quickLinkList.addEventListener('mousedown', (e) => mouseIsDown(e));
    quickLinkList.addEventListener('mouseup', (e) => mouseUp(e));
    quickLinkList.addEventListener('mouseleave', (e) => mouseLeave(e));
    quickLinkList.addEventListener('mousemove', (e) => mouseMove(e));

    function mouseIsDown(e) {
      isDown = true;
      startX = e.pageX - quickLinkList.offsetLeft;
      scrollLeft = quickLinkList.scrollLeft;
    }
    function mouseUp(e) {
      isDown = false;
    }
    function mouseLeave(e) {
      isDown = false;
    }
    function mouseMove(e) {
      if (isDown) {
        e.preventDefault();
        // Move horizontally
        const x = e.pageX - quickLinkList.offsetLeft;
        const walkX = (x - startX) * 1;
        quickLinkList.scrollLeft = scrollLeft - walkX;
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
